const defaultKey = 'default';
class ApiAbortManager {
    /** 직후 사용할 AbortController을 담아둡니다. */
    _currentController = new AbortController();
    /** 사용한 AbortController를 키에따라 담아둔 객체, 내부의 값은 완료된 api의 Controller일 가능성도 있습니다. */
    _controllerContainer = {
        default: [],
    };
    constructor() {
        this._init();
    }
    /**
     * abort every controller on list
     */
    _abortControllerList = (key) => {
        try {
            this._controllerContainer[key].forEach((controller) => {
                controller.abort();
            });
        }
        catch (error) {
            console.log(error);
        }
    };
    _init() {
        this._resetController();
        this._resetControllerContainer();
    }
    _resetController() {
        this._currentController = new AbortController();
    }
    _resetControllerContainer() {
        this._controllerContainer = {
            default: [],
        };
    }
    _removeKeyOnContainer(key) {
        delete this._controllerContainer[key];
    }
    _createKey() {
        return new Date().getTime().toString() + this._controllerContainer.length;
    }
    _save(key) {
        if (typeof this._controllerContainer[key] !== 'object') {
            Object.assign(this._controllerContainer, {
                [key]: [],
            });
        }
        this._controllerContainer[key].push(this._currentController);
    }
    _abort(key) {
        if (!this._controllerContainer[key]) {
            return;
        }
        this._abortControllerList(key);
        this._removeKeyOnContainer(key);
    }
    /**
    * 현재 컨트롤러의 signal을 얻습니다.
    *
    * signal은 사용 후 초기화됩니다.
    *
    * 사용한 signal의 컨트롤러는 list에 쌓입니다.
    */
    getSignal() {
        const { signal } = this._currentController;
        this._save(defaultKey);
        this._resetController();
        return signal;
    }
    /**
    * 유니크 키를 소유한 간이 매니저를 생성하여 리턴합니다.
    *
    * save를 이용하여 특정 api를 따로 저장하거나 abort를 이용하여 저장한 특정 api만 abort 시킵니다.
    *
    * TODO: 현재 api를 다루는 컴포넌트의 위치가 가지각색임.
    * 하나의 다이얼로그에서 여러개 create가 필요할 수도 있음.
    */
    create() {
        const key = this._createKey();
        return {
            /**
            * create에 의해 만들어진 키를 이용해 특정 api를 저장합니다.
            */
            save: () => this._save(key),
            /**
            * 저장된 특정 api를 모두 abort 합니다.
            */
            abort: () => this._abort(key),
        };
    }
    /**
    * 저장된 모든 컨트롤러를 abort 합니다.
    */
    abortAll() {
        this._abort(defaultKey);
        this._init();
    }
}
export const apiAbortManager = new ApiAbortManager();
